import { csv } from 'd3-fetch'
import { addGroups } from './settings'


// const devFile = 'data-2019.csv';
const devFile = 'flyering-data.csv';
const prodFile = 'https://www.splcenter.org/sites/default/files/flyering-data.csv';

const devGroupsFile = 'flyering-groups.csv'
const prodGroupsFile = 'https://www.splcenter.org/sites/default/files/flyering-groups.csv';


const groups = {};
['State', 'Ideology', 'Group', 'Type'].forEach(group => {
  groups[group] = {
    group, counts: {}, top: {},
  }
})

const types = {
  'banner-Public': 'Banners',
  'banner-Campus': 'Banners',
  'flier-Public': 'Public Flyers',
  'flier-Campus': 'Campus Flyers',
};

class DataLoader {
  constructor() {
    this._loaded = false;
    this._data = null;
  }

  _parseRow(row) {
    row.Group = row.Group.includes('Identity Evropa')
      ? row.Group.replace(/ \/ /g, '/').trim()
      : row.Group.trim();
    row.Type = types[`${row['Flier Type']}-${row['Location Type']}`];
    row.dateString = row.Date;
    const datePieces = row.dateString.split('/').map(d => parseInt(d, 10));
    // check for 2-digit years
    datePieces[2] = datePieces[2] < 100 ? +`20${datePieces[2]}` : datePieces[2];
    row.datePieces = datePieces;
    row.date = new Date(datePieces[2], datePieces[0] - 1, datePieces[1]).valueOf();
    Object.keys(groups).forEach(group => {
      const value = row[group];
      if (!groups[group].counts.hasOwnProperty(value)) {
        groups[group].counts[value] = 0;
      }
      groups[group].counts[value]++;
    })
  }

  load() {
    return new Promise((resolve, reject) => {
      const path = process.env.NODE_ENV === 'development'
        ? `${process.env.PUBLIC_URL}/${devGroupsFile}`
        : prodGroupsFile;
      csv(path).then(groupData => {
        addGroups(groupData)

        const path = process.env.NODE_ENV === 'development'
        ? `${process.env.PUBLIC_URL}/${devFile}`
        : prodFile;
        // const path = `${process.env.PUBLIC_URL}/${devFile}`;
        csv(path).then(data => {
          //
          data = data.map(datum => {
            datum.Group = datum.Group === 'Identity Evropa'
              ? 'American Identity Movement/Identity Evropa'
              : datum.Group;
            return datum;
          });
          //
          data.forEach((datum) => this._parseRow(datum));
          // check for missing lat or lon
          data = data.filter(datum => {
            const hasLocation = datum.Latitude && datum.Longitude;
            if (!hasLocation) {
              console.warn(`
                Missing Latitude and Longitude:
                ${datum.Type} | ${datum.Date} | ${datum.City}, ${datum.State}
              `);
            }
            return hasLocation;
          });
          Object.keys(groups).forEach(groupName => {
            const group = groups[groupName];
            group.top = Object.keys(group.counts).map(k => {
              return {
                name: k,
                count: group.counts[k],
                selected: true,
              };
            }).sort((a, b) => {
              return b.count - a.count;
            }).filter((g, i) => {
              if (groupName === 'Group') {
                return groupData.find(d => d.Group === g.name)
              }
              return i < 3;
            });
            if (group.top.length < Object.keys(group.counts).length) {
              group.top.push({
                name: 'Other',
                count: (
                    Object.keys(group.counts).map(k => group.counts[k]).reduce((a, v) => a + v)
                    -
                    group.top.map(t => t.count).reduce((a, v) => a + v)
                  ),
                selected: true,
              });
            }
            group.values = Object.keys(group.counts).sort();
          })
          resolve({groups, data});
        })
      })
    });
  }
}

export default new DataLoader()
